/**
 * Mobile-safe ID generator that works across all browsers.
 * Falls back to a timestamp + random string if crypto.randomUUID is unavailable.
 */
export function createId(): string {
  try {
    // Check if crypto.randomUUID is available (not supported in all mobile browsers)
    if (typeof globalThis.crypto?.randomUUID === 'function') {
      return globalThis.crypto.randomUUID();
    }
  } catch {
    // Fallback if crypto.randomUUID throws
  }
  
  // Fallback: timestamp + random string
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).slice(2, 11);
  const randomPart2 = Math.random().toString(36).slice(2, 11);
  return `${timestamp}-${randomPart}-${randomPart2}`;
}
